import React from "react";

function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">Terms & Conditions</h1>

        <div className="bg-gray-900/50 border border-gray-800/50 rounded-2xl overflow-hidden">
          <iframe
            src="/influencer_terms_conditions.pdf"
            title="Terms and Conditions"
            className="w-full"
            style={{ height: "80vh" }}
          />
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
